import _ from 'lodash'

export function setLocale(locale: string) {
    localStorage.setItem('locale', locale)
}

export function getLocale() {
    const locale = localStorage.getItem('locale')
    if (_.includes(['cn', 'en'], locale)) {
        return locale
    }
    return 'cn'
}
